<template>
  <span
    :class="['ui-badge-ordination', `ui-badge-ordination--${variant}`]"
  >
    {{ value }}
  </span>
</template>

<script>
// TODO: Use zilla z-badge-ordination when
// value prop accepts string as value.
export default {
  name: 'UiBadgeOrdination',
  props: {
    variant: {
      type: String,
      default: 'outline',
      validator: value => ['outline', 'solid'].includes(value),
    },
    value: {
      type: String,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.ui-badge-ordination {
  align-items: center;
  background-color: var(--z-badge-ordination-background);
  border-radius: var(--z-badge-ordination-border-radius);
  color: var(--z-badge-ordination-color);
  cursor: default;
  display: inline-flex;
  font-size: var(--z-badge-ordination-font-size);
  font-weight: var(--z-badge-ordination-font-weight);
  height: var(--z-badge-ordination-height);
  justify-content: center;
  letter-spacing: normal;
  line-height: var(--z-badge-ordination-line-height);
  padding: 0 var(--unit-0100);
  text-align: center;
  text-transform: uppercase;
  vertical-align: middle;
  width: var(--z-badge-ordination-width);
}

.ui-badge-ordination--solid {
  background-color: var(--z-badge-ordination-background-completed-selected);
  color: var(--z-badge-ordination-color-completed-selected);
}

.ui-badge-ordination--outline {
  background-color: var(--z-badge-ordination-background-current-unselected);
  border-color: var(--z-badge-ordination-border-color-current-unselected);
  border-style: solid;
  border-width: var(--z-badge-ordination-border-width-current-unselected);
  color: var(--z-badge-ordination-color-current-unselected);
}
</style>
